<template>
  <VView class="winners" back-button-to="/menu" header="Laureaci" v-if="this.entries.length">
    <div class="winners__group" v-for="winnersGroup in winnersByType" :key="winnersGroup.type">
      <VText center>{{ winnersGroup.type }}</VText>

      <ul class="winners__grid" >
        <li class="winners__item" v-for="entryId in winnersGroup.ids" :key="entryId">
          <VBlock class="winners__frame">
            <img :src="getEntryById(entryId).result.attachment" />
          </VBlock>
        </li>
      </ul>
    </div>
  </VView>
</template>

<script>
import { method } from 'lodash';

export default {
  name: 'Gallery',

  data: () => ({
    entries: [],
    pages: [],
    winnersByType: [
      { type: 'LEGO', ids: [
        '66eebd172ed24820b912ab25',
        '66f6ca172ed24820b912ac71',
        '66fc4eb12ed24820b912ad88',
      ] },
      { type: 'Bluza', ids: [
        '66eee5ae2ed24820b912ab37',
        '66efe5202ed24820b912ab50',
        '66f54cdc2ed24820b912ac1f',
        '66f6b1062ed24820b912ac6f',
        '66faf7d72ed24820b912ad60',
      ] },
      { type: 'Kubek', ids: [
        '66f30d9b2ed24820b912abd5',
        '66f3fcfe2ed24820b912abe4',
        '66f4fca12ed24820b912ac14',
        '66f893692ed24820b912acc6',
        '66f996b72ed24820b912ad0a',
        '66f9ae642ed24820b912ad19',
        '66faa8ab2ed24820b912ad3a',
        '66fae2ae2ed24820b912ad4d',
        '66fb02872ed24820b912ad6c',
        '66e88655e7e4033197612b95',
      ] },
      { type: 'Notes', ids: [
        '66ec68ae2ed24820b912aac6',
        '66eee83f2ed24820b912ab3b',
        '66f01b602ed24820b912ab71',
        '66f47ab32ed24820b912ac13',
        '66f697792ed24820b912ac61',
        '66f7c0d72ed24820b912ac97',
        '66f945412ed24820b912acdc',
        '66f9a2502ed24820b912ad0d',
        '66fb037e2ed24820b912ad6d',
        '66e886f9e7e4033197612b99',
      ] },
      { type: 'Poduszka', ids: [
        '66e888a7e7e4033197612b9d',
        '66e97234e7e4033197612bb2',
        '66e985bde7e4033197612bba',
        '66e9908ee7e4033197612bc4',
        '66e9efaae7e4033197612c02',
        '66ec31092ed24820b912aabe',
        '66ec8d322ed24820b912aacf',
        '66f11c3f2ed24820b912ab92',
        '66f135c82ed24820b912ab97',
        '66f1c7e72ed24820b912abb7',
        '66f45b8f2ed24820b912abf9',
        '66f525122ed24820b912ac17',
        '66f557092ed24820b912ac26',
        '66f6a8632ed24820b912ac6d',
        '66f80e052ed24820b912acb6',
        '66f940ca2ed24820b912acd9',
        '66f943522ed24820b912acdb',
        '66f94f592ed24820b912ace7',
        '66f95f9c2ed24820b912acef',
        '66fadc132ed24820b912ad46',
        '66fadc4f2ed24820b912ad48',
        '66fafae42ed24820b912ad65',
      ] },
    ]
  }),

  async mounted() {
    const { data: entries } = await this.$bricodes.getPublicEntries();

    this.entries = entries.filter(entry => entry.isConfirmed && !entry.isFavorite).reverse();
  },

  methods: {
    getEntryById(entryId) {
      return this.entries.find(entry => entry._id === entryId);
    },
  },
};
</script>

<style lang="scss" scoped>
.winners {
  &__grid {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;
  }

  &__item {
    flex: 1 1 33.3333%;
    max-width: 33.3333%;
    padding: 13px 18px;

    @media screen and (max-width: 800px) {
      flex: 1 1 50%;
      max-width: 50%;
    }

    @media screen and (max-width: 550px) {
      flex: 1 1 100%;
      max-width: 100%;
    }

    ::v-deep .text {
      margin-top: -10%;
      font-size: 20px;
      line-height: 1.25em;
    }
  }

  &__frame {
    // cursor: pointer;
    // transition: transform 0.25s ease-in-out;

    // &:hover {
    //   transform: scale(1.1);
    // }
  }
}
</style>
